import React from 'react'
import { I18n, Translate } from 'react-redux-i18n'

const CityFilterCloud = ({
  cities,
  selectedCities,
  onChange,
  idPrefix,
}) => {
  const selectedCitySet = new Set(selectedCities)

  const toggleCity = city => {
    if (selectedCitySet.has(city)) {
      onChange(selectedCities.filter(selectedCity => selectedCity !== city))
      return
    }

    onChange([...selectedCities, city])
  }

  return (
    <div>
      <label>
        <Translate value="search.city" />
      </label>
      <div>
        <div
          className={`recommendedEvent text-center cursor-pointer ${
            selectedCities.length === 0 ? 'recommendedEvent-checked' : ''
          }`}
          onClick={() => onChange([])}
        >
          {I18n.t('search.all_cities')}
        </div>
        {cities.map(city => (
          <div
            key={`${idPrefix}-${city}`}
            className={`recommendedEvent text-center cursor-pointer ${
              selectedCitySet.has(city) ? 'recommendedEvent-checked' : ''
            }`}
            onClick={() => toggleCity(city)}
          >
            {city}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CityFilterCloud
